import { useTranslation } from 'react-i18next';
import { useSelectedFilterItems } from '@/features/connect-dots/hooks/useSelectedFilterItems';
import clsx from 'clsx';

export const FilterResetButton = ({ className }: { className?: string }) => {
  const { t } = useTranslation();
  const { clearNodes, selectedFilterItems } = useSelectedFilterItems();
  const isDisabled = selectedFilterItems.length === 0;

  const handleClick = () => {
    clearNodes();
  };

  return (
    <button
      className={clsx(
        'inline-flex items-center justify-center rounded-md border border-rw-light-gray bg-white px-3 py-1 text-sm text-red-600 transition-colors hover:bg-rw-light-gray/30 hover:text-red-700 disabled:cursor-not-allowed disabled:opacity-40',
        className
      )}
      onClick={handleClick}
      disabled={isDisabled}
    >
      {t('リセット')}
    </button>
  );
};
